import React, { useEffect, useState } from "react";
import { CheckIcon, KeyIcon } from "@heroicons/react/solid";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
  ToastContainer,
} from "react-bootstrap";
import Select from "react-select";
import { XCircleIcon } from "@heroicons/react/outline";
import {
  useCheckUserDetailsMutation,
  useGetVendorListMutation,
  useSmscRegistrationMutation,
} from "Services/services";
import "react-phone-input-2/lib/style.css";
import { Toast } from "react-bootstrap";

// import { UserOnboardingListTable } from "./Tables";
import { MdOutlineAutoMode } from "react-icons/md";
import { Routes } from "routes";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCircleInfo } from "react-icons/fa6";
import { useHistory } from "react-router-dom";

export default () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");
  const [enterpriseName, setEnterpriseName] = useState("");
  const [password, setPassword] = useState("");

  const [userOnboard] = useSmscRegistrationMutation();
  const [verify] = useCheckUserDetailsMutation();
  const [refreshTable, setRefreshTable] = useState(false);

  // Get the usertype from localStorage
  const loggedUserData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(loggedUserData);
  // const [currencyOptions, setCurrencyOptions] = useState([]);
  // const [cost, setCost] = useState();
  // const [dltCost, setDltCost] = useState();
  // const [refund, setRefund] = useState();
  const [instances, setInstances] = useState("");
  const [sourceAddrNpi, setSourceAddrNpi] = useState("");
  const [sourceAddrTon, setSourceAddrTon] = useState("");
  const [throughput, setThroughput] = useState("");
  const [destAddrTon, setDestAddrTon] = useState("");
  const [destAddrApi, setDestAddrApi] = useState("");

  const history = useHistory();

  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(null);
  // const [entUser, setEntUser] = useState();

  // const serviceTypeOptions = [
  //   { value: "transactional", label: "Transactional" },
  //   { value: "professional", label: "Professional" },
  //   { value: "any", label: "Any" },
  // ];
  // const [serviceType, setServiceType] = useState();
  // const [dltType, setDltType] = useState();
  // const [channel, setChannel] = useState();
  const [session, setSession] = useState();
  const [altCharset, setAltCharset] = useState();
  const [port, setPort] = useState("");
  // const [tps, setTps] = useState();
  const [smsType, setSmsType] = useState();
  // const dltTypeOptions = [
  //   { value: "default", label: "Default" },
  //   { value: "whitelisted", label: "Whitelisted" },
  // ];
  // const channelOptions = [
  //   { value: "sms", label: "SMS" },
  //   { value: "whatsapp", label: "Whatsapp" },
  // ];
  const smsTypeOptions = [
    { value: "domestic", label: "Domestic" },
    { value: "international", label: "International" },
  ];
  const sessionOptions = [
    { value: "tx", label: "TX" },
    { value: "rx", label: "RX" },
    { value: "trx", label: "TRX" },
  ];
  const altCharsetOptions = [
    { value: "utf", label: "UTF-8" },
    { value: "gsm", label: "GSM-7" },
    { value: "ascii", label: "ASCII" },
    { value: "default", label: "Default" },
  ];
  const [userDropDown] = useGetVendorListMutation();
  const [ipParts, setIpParts] = useState(["", "", "", ""]);
  const [selectedRoute, setSelectedRoute] = useState("SMPP");
  const [smscId, setSmscId] = useState("");

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    fetchUserDropdown();
    // eslint-disable-next-line
  }, []);

  const fetchUserDropdown = async () => {
    userDropDown({ page: 1, limit: 1000, search: "" })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const items = response?.data?.data?.items || [];
          const userOptions = items.map((user) => ({
            value: user.id,
            label: user.vendor_name,
          }));
          setUsers(userOptions);
        } else {
          console.error("Failed to fetch user data", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching user data", error);
      });
  };

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  const generatePassword = () => {
    const length = 12;
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const symbols = "@$!%*?&#^";

    const all = lower + upper + numbers + symbols;

    let password = "";
    password += lower[Math.floor(Math.random() * lower.length)];
    password += upper[Math.floor(Math.random() * upper.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += symbols[Math.floor(Math.random() * symbols.length)];

    for (let i = 4; i < length; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }

    // Shuffle password to remove predictable pattern
    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");

    setPassword(password);
  };

  const userData = {
    vendor: user?.value,
    instances: instances,
    smsc_id: smscId,
    alt_charset: altCharset?.label,
    host: ipParts.join("."),
    port: port,
    smsc_username: enterpriseName,
    smsc_password: password,
    system_type: selectedRoute,
    source_addr_npi: sourceAddrNpi,
    source_addr_ton: sourceAddrTon,
    throughput: throughput,
    transceiver_mode: session?.label,
    dest_addr_npi: destAddrApi,
    dest_addr_ton: destAddrTon,
    smsc_type: smsType?.label,
    user_id: userObject.id,
    user_chain: userObject.user_type,
    vendor_chain: "parth#saraswat",
  };
  const [selectErrors, setSelectErrors] = useState({
    user: false,
    altCharset: false,
    password: false,
  });

  const submitForm = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    // Validate react-select separately
    const isUserValid = !!user;
    const isAltCharsetValid = !!altCharset;
    const isModeValid = !!session;
    const isSMStypeValid = !!smsType;
    const isIPValid =
      ipParts.length === 4 &&
      ipParts.every((part) => {
        const num = Number(part);
        return /^\d{1,3}$/.test(part) && num >= 0 && num <= 255;
      });
    const isPasswordValid =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$/.test(
        password
      );

    // console.log("check", !!user, user, isUserValid)
    const isFormValid = form.checkValidity();

    if (
      isUserValid &&
      isAltCharsetValid &&
      isModeValid &&
      isSMStypeValid &&
      isIPValid &&
      isPasswordValid &&
      isFormValid
    ) {
      userOnboard(userData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setToastMessage(success?.data?.message);
            setToastVariant("success");
            refreshFields();
            setRefreshTable(!refreshTable);
            setTimeout(() => {
              history.push(Routes.SMSCRegistration.path);
            }, 2000);
          } else if (success?.data?.statusCode > 300) {
            setToastMessage(success?.data?.message || "Upload failed!");
            setToastVariant("danger");
          }
          setShowToast(true);
        })
        .catch((error) => {
          setToastMessage("Upload failed!");
          setToastVariant("danger");
          setShowToast(true);
        });
    } else {
      setSelectErrors({
        user: !isUserValid,
        altCharset: !isAltCharsetValid,
        mode: !isModeValid,
        smsType: !isSMStypeValid,
        ip: !isIPValid,
        password: !isPasswordValid,
      });
    }
    setValidated(true);
  };

  const refreshFields = () => {
    setUser(null);
    setInstances("");
    setSmscId("");
    setAltCharset(null);
    setIpParts(["", "", "", ""]);
    setPort("");
    setEnterpriseName("");
    setPassword("");
    setSourceAddrNpi("");
    setSourceAddrTon("");
    setThroughput("");
    setDestAddrTon("");
    setDestAddrApi("");
    setSession(null);
    setSmsType(null);
    setSelectErrors({
      user: false,
      altCharset: false,
      mode: false,
      smsType: false,
      ip: false,
      password: false,
    });
    setValidated(false); // Reset validation state
    setisVerifiedUsername(undefined);
  };

  const [isVerifiedUsername, setisVerifiedUsername] = useState();

  const verifyUsername = (e) => {
    const username = e.target.value;
    setEnterpriseName(username);

    const regex = /^[a-zA-Z0-9._]{0,50}$/;

    if (username.length >= 3 && username.length <= 50 && regex.test(username)) {
      const postData = { data: username };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedUsername(true);
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedUsername(false);
          }
        })
        .catch((error) => {
          setisVerifiedUsername(false);
        });
    } else {
      setisVerifiedUsername(false);
    }
  };

  const handleRouteChange = (event) => {
    setSelectedRoute(event.target.value);
  };

  const handleIPChange = (index, value) => {
    if (value === "" || (/^\d{1,3}$/.test(value) && +value <= 255)) {
      const newParts = [...ipParts];
      newParts[index] = value;
      setIpParts(newParts);

      // Only clear the error if form has been validated and all IP parts are valid
      if (validated) {
        const updatedParts = [...newParts];
        const isIPValid =
          updatedParts.length === 4 &&
          updatedParts.every((part) => {
            const num = Number(part);
            return /^\d{1,3}$/.test(part) && num >= 0 && num <= 255;
          });

        setSelectErrors((prev) => ({
          ...prev,
          ip: !isIPValid,
        }));
      }
    }

    // const num = value.replace(/\D/g, ""); // remove non-digit characters
    // if (num <= 255) {
    //   const updated = [...ipParts];
    //   updated[index] = num;
    //   setIpParts(updated);
    // }
  };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card border={1} className="mb-3">
        <Card.Body className="p-0">
          <h5 className="mb-4">General information</h5>
          <Form
            noValidate
            validated={validated}
            onSubmit={submitForm}
            autoComplete="off"
          >
            <input
              type="text"
              name="preventAutoFill"
              style={{ display: "none" }}
            />
            <Row>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="userType">
                  <RequiredLabel label="Select Vendor" />
                  <Select
                    options={users}
                    placeholder="Select User"
                    className="mb-0"
                    isSearchable={true}
                    value={user}
                    onChange={(selectedOption) => {
                      setUser(selectedOption);
                      setSelectErrors((prev) => ({
                        ...prev,
                        user: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor:
                          validated && !user
                            ? "#dc3545"
                            : validated && user
                            ? "#65BB82"
                            : provided.borderColor,
                        borderRadius: "0.75rem",
                      }),
                    }}
                  />
                  {selectErrors.user && (
                    <div className="invalid-feedback d-block">
                      Vendor selection is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="instances">
                  <RequiredLabel label="Instances" />
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Instances"
                    value={instances}
                    className="mb-0"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^\d{1,4}$/.test(val)) {
                        setInstances(val);
                      }
                    }}
                    title="Instances must be a 1-4 digit positive number"
                    autoComplete="new-instances"
                  />
                  <Form.Control.Feedback type="invalid">
                    Enter a valid Instances.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="smscid">
                  <RequiredLabel label="SMSC ID" />
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter SMSC ID"
                    value={smscId} // ✅ Controlled value
                    pattern="^[a-zA-Z0-9]{0,8}$"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^[a-zA-Z0-9]{0,8}$/.test(val)) {
                        setSmscId(val); // ✅ Mutates the state
                      }
                    }}
                    title="SMSC ID must be alphanumeric, unique, 3-8 characters"
                    minLength={3}
                    autoComplete="new-smscId"
                  />
                  <Form.Control.Feedback type="invalid">
                    Enter a valid SMSC ID.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="altCharset">
                  <RequiredLabel label="ALT-Charset" />
                  <Select
                    options={altCharsetOptions}
                    placeholder="Select alt-charset"
                    className="mb-0"
                    isSearchable={true}
                    value={altCharset}
                    onChange={(val) => {
                      setAltCharset(val);
                      setSelectErrors((prev) => ({
                        ...prev,
                        altCharset: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor:
                          validated && !altCharset
                            ? "#dc3545"
                            : validated && altCharset
                            ? "#65BB82"
                            : "#ced4da",
                        borderRadius: "0.75rem",
                      }),
                    }}
                  />
                  {(selectErrors.altCharset || (validated && !altCharset)) && (
                    <div className="invalid-feedback d-block">
                      ALT-Charset selection is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="host">
                  <Form.Label className="d-flex align-items-center gap-1 mb-1">
                    <span>Host</span>
                    <span
                      className="d-flex align-items-center"
                      style={{ fontSize: "0.75rem" }}
                    >
                      <span style={{ color: "red" }}>*</span>
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip id="ip-tooltip">
                            Enter a valid IPv4 address in four parts (e.g.
                            192.168.0.1)
                          </Tooltip>
                        }
                      >
                        <span
                          className="ms-1 text-primary"
                          style={{ cursor: "pointer" }}
                        >
                          <FaCircleInfo size={18} />
                        </span>
                      </OverlayTrigger>
                    </span>
                  </Form.Label>

                  <div className="d-flex gap-2">
                    {[0, 1, 2, 3].map((index) => (
                      <Form.Control
                        key={index}
                        type="text"
                        value={ipParts[index] || ""}
                        onChange={(e) => handleIPChange(index, e.target.value)}
                        style={{
                          width: "60px",
                          textAlign: "center",
                          borderColor:
                            validated && selectErrors.ip
                              ? "#dc3545"
                              : validated && !selectErrors.ip
                              ? "#65BB82"
                              : "#ced4da",
                        }}
                        autoComplete={`ip-segment-${index}`}
                        isInvalid={validated && selectErrors.ip}
                        isValid={
                          validated &&
                          !selectErrors.ip &&
                          ipParts.every((part) => part !== "")
                        }
                      />
                    ))}
                  </div>
                  {(selectErrors.ip ||
                    (validated && ipParts.some((part) => part === ""))) && (
                    <div className="invalid-feedback d-block">
                      Enter a valid IP address.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="port">
                  <RequiredLabel label="Port" />
                  <Form.Control
                    required
                    type="number"
                    placeholder="Enter Port"
                    min={0}
                    max={65535}
                    value={port}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^\d+$/.test(val)) {
                        setPort(val);
                      }
                    }}
                    autoComplete="new-host"
                  />
                  <Form.Control.Feedback type="invalid">
                    Port must be between 1 and 65535.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="username">
                  <RequiredLabel label="SMSC Username" />
                  <InputGroup>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter Username"
                      value={enterpriseName}
                      onChange={verifyUsername}
                      minLength={3}
                      maxLength={50}
                      title="Username must be 3–50 characters, no special characters except _ and ."
                      autoComplete="new-username"
                    />
                    {isVerifiedUsername && (
                      <InputGroup.Text title="Username is available and unique">
                        <CheckIcon width={20} className="text-success" />
                      </InputGroup.Text>
                    )}
                    {isVerifiedUsername === false && (
                      <InputGroup.Text title="Username is not available or unique">
                        <XCircleIcon width={20} className="text-danger" />
                      </InputGroup.Text>
                    )}
                    <Form.Control.Feedback type="invalid">
                      Enter a valid username.
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="password">
                  <Form.Label className="d-flex align-items-center gap-1 mb-1">
                    <span>Password</span>
                    <span className="text-danger"> * </span>
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="ip-tooltip">
                          Password must be 8-32 characters, include uppercase,
                          lowercase, number, and special character.
                        </Tooltip>
                      }
                    >
                      <span
                        className="ms-1 text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        <FaCircleInfo size={18} />
                      </span>
                    </OverlayTrigger>
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <KeyIcon width={20} />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="password"
                      placeholder="Password"
                      value={password}
                      pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$"
                      title="Password must be 8-32 characters, include uppercase, lowercase, number, and special character."
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setPassword(newValue);
                        // Validate live feedback
                        const isValid =
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$/.test(
                            newValue
                          );
                        setSelectErrors((prev) => ({
                          ...prev,
                          password: !isValid,
                        }));
                      }}
                      isInvalid={validated && selectErrors.password}
                      maxLength={32}
                      autoComplete="new-password"
                    />
                    <InputGroup.Text>
                      <MdOutlineAutoMode
                        size={20}
                        onClick={generatePassword}
                        style={{ cursor: "pointer" }}
                        title="Auto-generate password"
                      />
                    </InputGroup.Text>
                  </InputGroup>
                  {selectErrors.password && (
                    <div className="invalid-feedback d-block">
                      Password is not strong enough.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="accountTypeOptions">
                  <RequiredLabel label="System Type" />
                  {/* <div className="d-flex flex-wrap justify-content-around"> */}
                  <div className="d-flex flex-wrap justify-content-start">
                    <Form.Check
                      type="radio"
                      id="smpp"
                      label="SMPP"
                      name="accountTypeOptions"
                      value="SMPP"
                      className="me-3"
                      onChange={handleRouteChange}
                      checked={selectedRoute === "SMPP"}
                    />
                    {/* <Form.Check
                        type="radio"
                        id="web"
                        label="WEB"
                        name="accountTypeOptions"
                        value="WEB"
                        className="me-3"
                        onChange={handleRouteChange}
                        checked={selectedRoute === "WEB"}
                      />
                      <Form.Check
                        type="radio"
                        id="api"
                        label="API"
                        name="accountTypeOptions"
                        value="API"
                        onChange={handleRouteChange}
                        checked={selectedRoute === "API"}
                      /> */}
                    {/* <Form.Check
                        type="radio"
                        id="whatsapp"
                        label="WHATSAPP"
                        name="accountTypeOptions"
                        value="whatsapp"
                        onChange={handleRouteChange}
                        checked={selectedRoute === "whatsapp"}
                      /> */}
                    {/* <Form.Check
                        type="radio"
                        id="rcs"
                        label="RCS"
                        name="accountTypeOptions"
                        value="rcs"
                        onChange={handleRouteChange}
                        checked={selectedRoute === "rcs"}
                      /> */}
                  </div>
                  {/* {validationError && (
                      <div className="invalid-feedback d-block">
                        Please select a valid route.
                      </div>
                    )} */}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="sourceAddrNpi">
                  <RequiredLabel label="Source-Addr-Npi" />
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Addr-NPI"
                    value={sourceAddrNpi}
                    className="mb-0"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^\d{1,4}$/.test(val)) {
                        setSourceAddrNpi(val);
                      }
                    }}
                    autoComplete="new-instances"
                    title="Source-Addr-Npi must be a 1-4 digit positive number"
                  />
                  <Form.Control.Feedback type="invalid">
                    Invalid Source Addr NPI.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="sourceAddrTon">
                  <RequiredLabel label="Source-Addr-Ton" />
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Addr-Ton"
                    value={sourceAddrTon}
                    className="mb-0"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^\d{1,4}$/.test(val)) {
                        setSourceAddrTon(val);
                      }
                    }}
                    autoComplete="new-instances"
                    title="Source-Addr-Ton must be a 1-4 digit positive number"
                  />
                  <Form.Control.Feedback type="invalid">
                    Invalid Source Addr TON.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="throughput">
                  <RequiredLabel label="Throughput" />
                  <Form.Control
                    required
                    type="number"
                    placeholder="Enter Throughput"
                    value={throughput}
                    className="mb-0"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^\d{1,4}$/.test(val)) {
                        setThroughput(val);
                      }
                    }}
                    max={1000}
                    autoComplete="new-instances"
                    title="Throughput must be a 1-4 digit positive number, max 1000"
                  />
                  <Form.Control.Feedback type="invalid">
                    Invalid Throughput.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="destAddrApi">
                  <RequiredLabel label="Dest-Addr-Npi" />
                  <Form.Control
                    required
                    type="number"
                    placeholder="Enter Addr-Npi"
                    value={destAddrApi}
                    className="mb-0"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^\d{1,4}$/.test(val)) {
                        setDestAddrApi(val);
                      }
                    }}
                    autoComplete="new-instances"
                    title="Dest-Addr-Npi must be a 1-4 digit positive number"
                  />
                  <Form.Control.Feedback type="invalid">
                    Invalid Dest-Addr-Npi.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="destAddrTon">
                  <RequiredLabel label="Dest-Addr-Ton" />
                  <Form.Control
                    required
                    type="number"
                    placeholder="Enter Addr-Ton"
                    value={destAddrTon}
                    className="mb-0"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^\d{1,4}$/.test(val)) {
                        setDestAddrTon(val);
                      }
                    }}
                    autoComplete="new-instances"
                    title="Dest-Addr-Ton must be a 1-4 digit positive number"
                  />
                  <Form.Control.Feedback type="invalid">
                    Invalid Dest-Addr-Ton.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="transceiverMode">
                  <RequiredLabel label="Transceiver Mode" />
                  <Select
                    options={sessionOptions}
                    placeholder="Select Transceiver Mode"
                    className="mb-0"
                    isSearchable={true}
                    value={session}
                    onChange={(val) => {
                      setSession(val);
                      setSelectErrors((prev) => ({
                        ...prev,
                        mode: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor:
                          validated && !session
                            ? "#dc3545"
                            : validated && session
                            ? "#65BB82"
                            : provided.borderColor,
                        borderRadius: "0.75rem",
                      }),
                    }}
                  />
                  {(selectErrors.mode || (validated && !session)) && (
                    <div className="invalid-feedback d-block">
                      Transceiver Mode selection is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="smsType">
                  <RequiredLabel label="SMS Type" />
                  <Select
                    options={smsTypeOptions}
                    placeholder="Select SMS Type"
                    className="mb-0"
                    isSearchable={true}
                    value={smsType}
                    onChange={(val) => {
                      setSmsType(val);
                      setSelectErrors((prev) => ({
                        ...prev,
                        smsType: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor:
                          validated && !smsType
                            ? "#dc3545"
                            : validated && smsType
                            ? "#65BB82"
                            : provided.borderColor,
                        borderRadius: "0.75rem",
                      }),
                    }}
                  />
                  {(selectErrors.smsType || (validated && !smsType)) && (
                    <div className="invalid-feedback d-block">
                      SMS type selection is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              {/* <Col md={6} className="mb-3">
                  <Form.Group id="ip">
                    <Form.Label className="d-flex align-items-center gap-1 mb-1">
                      <span>IP Address</span>
                      <span className="d-flex align-items-center" style={{ fontSize: '0.75rem' }}>
                        <span style={{ color: 'red' }}>*</span>
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Tooltip id="ip-tooltip">
                              Enter a valid IPv4 address in four parts (e.g. 192.168.0.1)
                            </Tooltip>
                          }
                        >
                          <span className="ms-1 text-primary" style={{ cursor: 'pointer' }}>
                            <FaCircleInfo size={18} />
                          </span>
                        </OverlayTrigger>
                      </span>
                    </Form.Label>

                    <div className="d-flex gap-2">
                      {[0, 1, 2, 3].map((index) => (
                        <Form.Control
                          key={index}
                          type="text"
                          value={ipParts[index] || ''}
                          onChange={(e) => handleIPChange(index, e.target.value)}
                          maxLength="3"
                          style={{ width: '60px', textAlign: 'center' }}
                          autoComplete={`ip-segment-${index}`}
                        />
                      ))}
                    </div>
                  </Form.Group>
                </Col> */}

              {/* <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="dltTypeLabel">
                    <RequiredLabel label="DLT Type" />
                    <Select
                      options={dltTypeOptions}
                      placeholder="--Select DLT Type--"
                      className="mb-0"
                      isSearchable={true}
                      value={dltType}
                      onChange={setDltType}
                    />
                  </Form.Group>
                </Col> */}
            </Row>

            <div className="mt-3 d-flex">
              <Button
                variant="secondary"
                className="animate-up-2 ms-auto"
                type="submit"
              >
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
